import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.tsx';
import { FC } from 'react';
import { StreamState } from '@/__generated__/graphql.ts';
import { streamStateIndicator } from '@/components/stream-list/stream-card/stream-card.css.ts';

export const StreamStateIndicator: FC<{ streamState: StreamState }> = ({
  streamState,
}) => (
  <Tooltip disableHoverableContent>
    <TooltipTrigger asChild>
      <div
        className={streamStateIndicator}
        data-active={streamState === StreamState.Active ? '' : undefined}
      />
    </TooltipTrigger>
    <TooltipContent
      description={
        streamState === StreamState.Active
          ? `Active stream indicates that an author posts regularly.`
          : `Inactive stream indicates that an author doesn't post often.`
      }
    />
  </Tooltip>
);
